import { OtherPageQuery } from '@layouts/other'

const Other = (props) => {
  return (
    <OtherPageQuery {...props} />
  )
}

Other.getInitialProps = async ({ query, asPath }) => {
  return ({ query, asPath })
}

export default Other
